export default __webpack_public_path__ + "static/media/member-jack.6660accd.jpg";